import React from "react";
import {
  ProductRowImage,
  ProductDelete,
  ProductRowDetails,
  CheckboxProductSoldOut,
} from "./components";
import { useProductDetailsForm, useWatchProductForm } from "./hooks";
import FormContext from "../../../../../../../../context/formContext";
import { mapProductObjectToForm } from "../../../../../../../../utils";
import "./index.scss";

/**
 * @desc Product row.
 */
export const ProductRow = ({ product }) => {
  const { number } = product;
  const formProduct = mapProductObjectToForm(product);
  const { control, watch } = useProductDetailsForm(formProduct);

  // SIDE EFFECTS -------------------------------------------------------------

  useWatchProductForm({ watch, product, formProduct });

  // COMPONENT ----------------------------------------------------------------

  const context = { control };

  return (
    <FormContext.Provider value={context}>
      <tr className="product-row">
        <td>
          <div className={"flex number-container"}>
            {number && <div className={"flex number"}>{number}</div>}
          </div>
        </td>
        <td>
          <ProductRowImage product={product} />
        </td>
        <td>
          <ProductRowDetails product={product} />
        </td>
        <td>
          <CheckboxProductSoldOut product={product} />
        </td>
        <td>
          <ProductDelete product={product} />
        </td>
      </tr>
    </FormContext.Provider>
  );
};
